import { Component, OnInit } from '@angular/core';
import { INotice } from '../../shared/classes/notice';
import { SystemService } from '../../services/system.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

@Component({
  templateUrl: './notice.component.html'
})
export class NoticeTextComponent implements OnInit {
    noticeList: INotice[];
    myNotice: INotice = {
        id: 0,
        type: '',
        text1: '',
        text2: ''
    };

    isNewEntry = false;
    userType = '';
    
    displayState: any = {
        workingDiv: false,
        noticeDiv: false,
        gridDiv: true,
        editNoticeDiv: false,
        saveDisabled: false
    };


    constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

    ngOnInit() {
        this.displayState.gridDiv = true;
        this.displayState.noticeDiv = false;
        this.displayState.editUserDiv = false;
        this.loadNoticeList();
    }

    loadNoticeList() {
        this.displayState.workingDiv = true;
        this.systemService.getNoticeList().subscribe (data => {
            this.noticeList = [];
            this.noticeList = data;
            this.displayState.workingDiv = false;
        });
    }

    onSelect(notice: INotice) {
        // get the notice data; from grid or from API call??
        //
        // now, display the edit Fact form
        this.displayState.gridDiv = false;
        this.displayState.noticeDiv = true;
        this.isNewEntry = false;
        // set Fact data for display
        this.myNotice.id = notice.id;
        this.myNotice.type = notice.type;
        this.myNotice.text1 = notice.text1;
        this.myNotice.text2 = notice.text2;

        //
        this.displayState.editNoticeDiv = true;
        return true;
    }

    newNotice() {
        this.displayState.gridDiv = false;
        this.displayState.noticeDiv = true;
        this.isNewEntry = true;
        this.displayState.editNoticeDiv = true;
        // set notice data for display
        this.myNotice.id = 0;
        this.myNotice.type = '';
        this.myNotice.text1 = '';
      this.myNotice.text2 = '';
        //
        return true;
    }

  saveNotice() {
    // validate data...
    if (this.validateNoticeData() === false ) {
      this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
      return true;
    }
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    // save notice data
    this.systemService.saveNotice(this.myNotice).subscribe (data => {
      // once we get a response, hide the Edit window
      this.displayState.noticeDiv = false;
      this.displayState.editNoticeDiv = false;
      this.displayState.saveDisabled = false;
      // display grid div
      this.displayState.gridDiv = true;
      this.showToast({severity: 'success', summary: '', detail: 'Notice data updated.'});
      // refresh the grid/list
      this.loadNoticeList();
    });

    //
    return true;
  }

  validateNoticeData() {
    // validate required notice data; base it on value of any element w/ prd-required class??
    if ((this.myNotice.type === '') || (this.myNotice.text1 === '')) {
      return false;
    }
    return true;
  }

  deleteNotice(notice: INotice) {
    this.confirmationService.confirm({
        message: 'Do you want to delete this record?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.systemService.deleteNotice(notice).subscribe(data => {
            this.showToast({severity: 'success', detail: 'Notice has been DELETED.', summary: ''});
            this.loadNoticeList();
          });
        },
        reject: () => {
          this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
    });

    return true;
  }

  cancelEntry() {
    this.displayState.noticeDiv = false;
    this.displayState.editNoticeDiv = false;
    this.displayState.gridDiv = true;
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  showConfirm() {
    this.messageService.clear();
    this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
  }


  onConfirm() {
      this.messageService.clear('c');
  }

  onReject() {
      this.messageService.clear('c');
  }

  clear() {
    this.messageService.clear();
  }

}
